export class CapcodConfirmConfig {
    objectId: string;
    actionLabel = 'Supprimer';
    withReason = false;
    title = 'Confirmation de suppression';
    message = `Attention êtes vous certain de vouloir supprimer l'élément`;
}
